import { useEffect, useState } from 'react';
import { FileBarChart } from 'lucide-react';
import { ReportBuilder } from '../client/ReportBuilder';
import { API_BASE } from '../../utils/api-base';
import { sessionStorage as authSession } from '../../utils/auth-api';

interface ReportBuilderAdminTabProps {
  token: string;
}

interface ClientOption {
  id: string;
  name: string;
}

export function ReportBuilderAdminTab({ token }: ReportBuilderAdminTabProps) {
  const [clients, setClients] = useState<ClientOption[]>([]);
  const [clientId, setClientId] = useState('');
  const [loading, setLoading] = useState(true);

  const getToken = () => authSession.get()?.token || token || '';

  useEffect(() => {
    const t = getToken();
    if (!t) return;
    fetch(`${API_BASE}/api/clients`, { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => r.json())
      .then((d) => setClients((Array.isArray(d) ? d : d.clients || []).map((c: any) => ({ id: c.id, name: c.name }))))
      .catch(() => {})
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-4">
      <div className="px-6 pt-6 flex items-center gap-3">
        <FileBarChart className="h-5 w-5 text-muted-foreground" />
        <div className="flex-1 max-w-sm">
          <select
            value={clientId}
            onChange={(e) => setClientId(e.target.value)}
            className="w-full rounded-md border bg-background px-3 py-2 text-sm"
          >
            <option value="">{loading ? 'Loading clients…' : 'Select a client…'}</option>
            {clients.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
      </div>

      {clientId ? (
        <ReportBuilder clientId={clientId} token={getToken()} />
      ) : (
        <div className="p-10 text-center text-sm text-muted-foreground">
          Pick a client above to build or manage their custom reports — this works regardless of whether
          "Automated Report Generation" is enabled for that client, since you're managing it as super admin.
        </div>
      )}
    </div>
  );
}
